// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-style, func-names, prefer-named-capture-group */
import * as R from "ramda"

/**
 * This function detects which browser is running this script.
 * The order of the checks are important since many user agents
 * include key words used in later checks.
 */
function getBrowser() {
  const { userAgent } = window.navigator
  const vendor = window.navigator.vendor || "" // vendor is undefined for at least IE9
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { opera } = window as any

  const includes = function (str: string | "Apple Computer, Inc" | "Google Inc.", needle: string) {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-includes
    return str.indexOf(needle) !== -1
  }

  if (opera) {
    if (includes(userAgent, "Mini")) {
      return "Opera Mini"
    }
    return "Opera"
  }
  if (/(BlackBerry|PlayBook|BB10)/i.test(userAgent)) {
    return "BlackBerry"
  }
  if (includes(userAgent, "FBIOS")) {
    return "Facebook Mobile"
  }
  if (includes(userAgent, "Chrome")) {
    return "Chrome"
  }
  if (includes(userAgent, "CriOS")) {
    return "Chrome iOS"
  }
  if (includes(vendor, "Apple")) {
    if (includes(userAgent, "Mobile")) {
      return "Mobile Safari"
    }
    return "Safari"
  }
  if (includes(userAgent, "Android")) {
    return "Android Mobile"
  }
  if (includes(userAgent, "Konqueror")) {
    return "Konqueror"
  }
  if (includes(userAgent, "Firefox")) {
    return "Firefox"
  }
  if (includes(userAgent, "MSIE") || includes(userAgent, "Trident/")) {
    return "Internet Explorer"
  }
  if (includes(userAgent, "Gecko")) {
    return "Mozilla"
  }
  return "Unknown browser"
}

function getOS() {
  const { userAgent } = navigator
  if (/Windows/i.test(userAgent)) {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-includes
    if (/Phone/.test(userAgent)) {
      return "Windows Mobile"
    }
    return "Windows"
  }
  if (/(iPhone|iPad|iPod)/i.test(userAgent)) {
    return "iOS"
  }
  if (/Android/i.test(userAgent)) {
    return "Android"
  }
  if (/(BlackBerry|PlayBook|BB10)/i.test(userAgent)) {
    return "BlackBerry"
  }
  if (/Mac/i.test(userAgent)) {
    return "Mac OS X"
  }
  if (/Linux/i.test(userAgent)) {
    return "Linux"
  }
  return "Unknown OS"
}

export default {
  release: window.SP_GLOBALS.RELEASE_INFO,
  globals: {
    // @ts-expect-error: Flow to TS migration.
    SKYPICKER_PAGE: window.SP_GLOBALS.SKYPICKER_PAGE,
    // @ts-expect-error: Flow to TS migration.
    SKYPICKER_LNG: window.SP_GLOBALS.SKYPICKER_LNG,
    // @ts-expect-error: Flow to TS migration.
    SKYPICKER_CURRENCY: window.SP_GLOBALS.SKYPICKER_CURRENCY,
  },
  referrer: document.referrer,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  source: R.nth(2, document.referrer.split("/")) || "direct",
  userAgent: window.navigator.userAgent,
  browser: getBrowser(),
  os: getOS(),
  screenHeight: screen.height,
  screenWidth: screen.width,
}
